<template>
    <div>
      <v-navigation-drawer
        v-model="drawer"
        enable-resize-watcher
        fixed
        app
        class="grey darken-4"
      >
        <side-drawer></side-drawer>
      </v-navigation-drawer>
      <v-toolbar
        app
        color="primary"
        class="elevation-1"
      >
        <v-toolbar-side-icon @click.stop="drawer = !drawer" class="white--text"></v-toolbar-side-icon>
        <v-spacer></v-spacer>
        <v-toolbar-title class="white--text">Schematics</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          icon
          @click="items=[]; getSchematics(txtName, cboDeviceType, cboBrandId, cboStatus, cboSort); rightDrawer=false;"
        >
          <v-icon>autorenew</v-icon>
        </v-btn>
        <v-btn icon @click.stop="rightDrawer = !rightDrawer" class="white--text">
          <v-icon>filter_list</v-icon>
        </v-btn>
      </v-toolbar>
      <v-navigation-drawer
        temporary
        right
        v-model="rightDrawer"
        fixed
        app
        :width=500
      >
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex
              xs12
              text-xs-center
              layout
              align-center
              justify-center
              class="pl-4 pr-4"
            >
              <v-form ref="form" v-model="frmValid" lazy-validation @submit.prevent="">
                <v-text-field
                  v-model="txtName"
                  label="Name"
                  @keyup.enter="clickFilter()"
                ></v-text-field>
                <v-select
                  v-model="cboDeviceType"
                  :items="deviceTypes"
                  label="Device Type"
                ></v-select>
                <v-select
                  v-model="cboBrandId"
                  :items="brands"
                  item-text="brandName"
                  item-value="brandId"
                  label="Brand"
                ></v-select>
                <v-select
                  v-model="cboStatus"
                  :items="statuses"
                  label="Status"
                ></v-select>
                <v-select
                  v-model="cboSort"
                  :items="sorts"
                  item-text="title"
                  item-value="key"
                  label="Sorting"
                ></v-select>
                <v-btn
                  @click="clickFilter()"
                >
                  Filter
                </v-btn>
                <v-btn @click="clearFilter(); getSchematics(txtName, cboDeviceType, cboBrandId, cboStatus, cboSort); rightDrawer=false;">Reset</v-btn>
              </v-form>
            </v-flex>
          </v-layout>
        </v-container>
      </v-navigation-drawer>
      <v-content>
        <v-container v-if="items.length > 0" fluid grid-list-xs class="pa-0">
          <v-layout row wrap v-for="(item, index) in items" :key="item.schematicId" :class="(index % 2 === 0 ? 'row1' : 'row2')">
            <v-flex xs2 sm1 class="text-xs-center pa-2 pt-4 pb-3">
              <router-link :to="'/schematic/' + item.schematicId">
                <v-img v-if="item.image && item.image.mediumUrl" :src="item.image.mediumUrl" contain aspect-ratio="1.2"></v-img>
              </router-link>
            </v-flex>
            <v-flex xs6 sm7 class="text-xs-left pa-2 pt-3 pb-3">
              <div class="caption grey--text">
                {{ item.createdDateTime | formatDate('DD MMMM YYYY HH:mm', profile.gmtTimezone) }}
              </div>
              <div>
                <router-link class="font-weight-bold orange--text text--lighten-2" :to="'/schematic/' + item.schematicId">{{ item.name }}</router-link>
              </div>
              <div class="body-1">{{ item.brandName + ' ' + item.deviceType }}</div>
              <div class="caption grey--text">
                By {{ item.createdByAdminName }}
              </div>
            </v-flex>
            <v-flex xs4 sm3 class="text-xs-right pa-3">
            </v-flex>
            <v-flex sm1 class="text-xs-center pt-4 pr-3 pl-0 hidden-xs-only">
              <v-btn icon color="primary" :to="'/schematic/' + item.schematicId">
                <v-icon>keyboard_arrow_right</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
        <v-container v-else fluid grid-list-xs class="pa-0">
          <v-layout row wrap class="row1">
            <v-flex xs12 class="text-xs-center pa-2 pt-4 pb-4">
              <v-icon x-large color="primary">error_outline</v-icon>
              <div>
                No schematic found
              </div>
            </v-flex>
          </v-layout>
        </v-container>

        <v-container fluid grid-list-xs class="mt-3 mb-0">
          <v-layout row wrap>
            <v-flex xs12 class="text-xs-center">
              <div class="mb-3">
                Showing {{ listCountFrom }} - {{ listCountTo }} of {{ listTotal }} schematics
              </div>
            </v-flex>
            <v-flex xs12 class="text-xs-center hidden-sm-and-up">
              <v-pagination
                v-model="pageNo"
                :length="(pageCount ? pageCount : 0)"
                :total-visible="5"
                circle
              ></v-pagination>
            </v-flex>
            <v-flex xs12 class="text-xs-center hidden-xs-only">
              <v-pagination
                v-model="pageNo"
                :length="(pageCount ? pageCount : 0)"
                :total-visible="12"
                circle
              ></v-pagination>
            </v-flex>
          </v-layout>
        </v-container>
        <v-fab-transition>
          <v-btn
            color=primary
            dark
            fab
            fixed
            bottom
            right
            class="mb-4 mr-3"
            to="/schematic"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </v-fab-transition>
        <v-dialog
          v-model="loading"
          hide-overlay
          persistent
          width="220"
        >
          <loading></loading>
        </v-dialog>

      </v-content>
    </div>
  </template>

  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>

  .tabs__slider {
    height: 3px;
  }

  form {
    width: 100%;
  }

  </style>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import Loading from '@/components/Loading.vue'
// import moment from 'moment'
import axios from 'axios'
import router from '../router'
// import { EventBus } from '../main'

export default {
  components: {
    SideDrawer,
    Loading
  },
  data () {
    return {
      def: this.$store.getters.getDef,
      drawer: false,
      rightDrawer: false,
      loading: false,
      frmValid: true,
      txtName: '',
      cboDeviceType: '',
      deviceTypes: [
        {
          text: '',
          value: ''
        },
        {
          text: 'Phone',
          value: 'phone'
        },
        {
          text: 'Tablet',
          value: 'tablet'
        },
        {
          text: 'PC',
          value: 'pc'
        }
      ],
      cboBrandId: '',
      brands: [],
      cboStatus: 'active',
      statuses: [
        {
          text: 'Active',
          value: 'active'
        },
        {
          text: 'Disabled',
          value: 'disabled'
        }
      ],
      cboSort: '',
      sorts: [
        {
          key: 'createdDateTime:desc',
          title: 'Latest'
        },
        {
          key: 'createdDateTime:asc',
          title: 'From beginning'
        }
      ],
      isLoadingItems: false,
      items: [],
      listLimit: 15,
      listOffset: 0,
      listTotal: 0,
      listCountFrom: 0,
      listCountTo: this.listLimit,
      pageNo: parseInt(this.$route.query.pg) || 1,
      pageCount: 0
    }
  },
  computed: {
    profile () {
      return this.$store.getters.getProfile
    }
  },
  created () {
    // var _this = this
    // window.addEventListener('scroll', this.detectBottomOfWindow)
  },
  destroyed () {
    // window.removeEventListener('scroll', this.detectBottomOfWindow)
  },
  mounted () {
    this.openDrawerForDesktop()

    // init
    this.clearFilter()
    this.txtName = this.$route.query.name || ''
    this.cboDeviceType = this.$route.query.device_type || ''
    this.cboBrandId = this.$route.query.brand || ''
    this.cboSort = this.$route.query.sort || ''

    this.getSchematics(this.txtName, this.cboDeviceType, this.cboBrandId, this.cboStatus, this.cboSort)
    this.getBrands()
  },
  watch: {
    pageNo (val, oldVal) {
      // If page no changes, navigate to new page
      this.getSchematics(this.txtName, this.cboDeviceType, this.cboBrandId, this.cboStatus, this.cboSort, (val - 1) * this.listLimit)
    }
  },
  methods: {
    detectBottomOfWindow: function () {
      // console.log(document.documentElement.scrollTop + window.innerHeight) - 48
      // console.log(document.documentElement.offsetHeight)
      let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight >= (document.documentElement.offsetHeight - 5)

      if (bottomOfWindow) {
        if (this.listTotal > this.items.length) {
          this.getSchematics(this.txtName, this.cboDeviceType, this.cboBrandId, this.cboStatus, this.cboSort, this.items.length)
        }
      }
    },
    clickFilter: function () {
      this.items = []
      this.rightDrawer = false
      this.getSchematics(this.txtName, this.cboDeviceType, this.cboBrandId, this.cboStatus, this.cboSort)
    },
    getBrands: function () {
      var _this = this
      var promise = new Promise(function (resolve, reject) {
        _this.loading = true
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/brands')
          .then(resp => {
            _this.loading = false
            console.log(resp.data)
            if (resp.data.status === 'success') {
              resp.data.data.unshift({
                brandId: '',
                brandName: ''
              })
              _this.brands = resp.data.data
            } else {
              console.log('unable to load brands: ' + resp.data.message)
            }
            resolve()
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
                reject(error.response.status)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
                reject(error.response.status)
              }
              _this.loading = false
            }
          })
      })
      return promise
    },
    getSchematics: function (name = '', deviceType = '', brandId = '', status = '', sort = '', offset = 0) {
      var _this = this
      if (_this.isLoadingItems === false) {
        _this.isLoadingItems = true
        let params = '&name=' + name + '&device_type=' + deviceType + '&brand_id=' + brandId + '&status=' + status + '&sort=' + sort + '&limit=' + _this.listLimit + '&offset=' + offset
        _this.loading = true
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/schematics?' + params)
          .then(resp => {
            _this.loading = false
            if (resp.data.status === 'success') {
              _this.items = resp.data.data
              _this.listLimit = resp.data.limit
              _this.listOffset = resp.data.offset
              _this.listTotal = resp.data.total
              _this.pageCount = Math.ceil(_this.listTotal / _this.listLimit)
              _this.listCountFrom = _this.listOffset + 1
              _this.listCountTo = (_this.listCountFrom - 1) + _this.items.length
              if (_this.items.length === 0) {
                _this.listCountFrom = 0
                _this.listCountTo = 0
              }
            } else {
              console.log('unable to load schematics: ' + resp.data.message)
            }
            _this.isLoadingItems = false
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
              }
              _this.loading = false
              _this.isLoadingItems = false
            }
          })
      }
    },
    clearFilter () {
      this.cboStatus = this.status
      this.txtName = ''
      this.cboDeviceType = ''
      this.cboBrandId = ''
      this.cboSort = ''
      this.items = []
      this.listOffset = 0
      this.listTotal = 0
      this.pageCount = 1
      this.listCountFrom = 0
      this.listCountTo = 0
      this.pageNo = 1
      this.rightDrawer = false
    }
  }
}

</script>
